import {loadable} from "jotai/utils";
import {atomWithRefresh} from "../utils/jotaiUtils";
import {Authentication} from "../types/authentication";
import {getUserAuthentication} from "../services/authenticationService";
import {atom} from "jotai";

/**
 * Current user authentication properties
 */
export const authenticationAtom = atomWithRefresh<Promise<Authentication>>(async () => await getUserAuthentication());

export const authenticationLoadable = loadable(authenticationAtom);
export const isLoggingOutAtom = atom<boolean>(false);
